<div class="row">
  <div class="col-12 pricing-table-light">
    <div class="container-xl">
      <div class="pricing-table">
        <div class="title">
          <h3 class="f-p" data-aos="fade-down" data-aos-duration="500">
            Pricing Plans
          </h3>

          <p class="f-m" data-aos="fade-down" data-aos-duration="600">
            Plans to help every business dominate customer service for today's
            world
          </p>
        </div>
        <div class="table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th width="25%"></th>
                <th>
                  <span class="col-title">Plan A</span>
                </th>
                <th>
                  <span class="col-title">Plan B</span>
                </th>
                <th>
                  <span class="col-title">Plan C</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span class="price-label">
                    Select a plan based on your exact needs
                  </span>
                </td>
                <td>
                  <div class="price-col">
                    <span>$125</span>
                    per month
                  </div>
                </td>
                <td>
                  <div class="price-col">
                    <span>$125</span>
                    per month
                  </div>
                </td>
                <td>
                  <div class="price-col">
                    <span>$125</span>
                    per month
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="price-label"> Month to Month </span>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="price-label">
                    Unlimited calls to the continental U.S. & Canada
                  </span>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="price-label"> Concurrent licensing </span>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
                <td>
                  <div class="check-icon">
                    <i class="bi bi-check-lg"></i>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div class="text-center">
                    <button class="primaryBtn">SIGN UP NOW</button>
                  </div>
                </td>
                <td>
                  <div class="text-center">
                    <button class="primaryBtn">START TRIAL</button>
                  </div>
                </td>
                <td>
                  <div class="text-center">
                    <button class="primaryBtn">CONTACT SALES</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <app-book-consultation [title]="title" class="spa0 col-12" />
  <app-transform-customer-service class="spa0 col-12" />
  <app-contact-us class="spa0 col-12" />
</div>
